/**
 * Funding - Represents funding source information for pay items.
 * Used to track funding sources, percentages, and federal participation.
 */
export class Funding {
  /** Funding code identifier */
  Code: number;

  /** Name of the funding source */
  Name: string;

  /** Payer organization or entity */
  Payer: string;

  /** Percentage of funding from this source */
  Percentage: number;

  /** Indicates if this funding source has federal participation */
  FederalParticipation: boolean;

  /**
   * Creates a new Funding instance
   * @param data - Object containing funding properties
   */
  constructor(data: {
    Code: number;
    Name: string;
    Payer: string;
    Percentage: number;
    FederalParticipation: boolean;
  }) {
    this.Code = data.Code;
    this.Name = data.Name;
    this.Payer = data.Payer;
    this.Percentage = data.Percentage;
    this.FederalParticipation = data.FederalParticipation;
  }

  /**
   * Creates a Funding from a plain object (useful for deserialization)
   * @param obj - Plain object with funding data
   * @returns New Funding instance
   */
  static fromObject(obj: Partial<Funding>): Funding {
    return new Funding({
      Code: obj.Code ?? 0,
      Name: obj.Name ?? "",
      Payer: obj.Payer ?? "",
      Percentage: obj.Percentage ?? 0,
      FederalParticipation: obj.FederalParticipation ?? false,
    });
  }

  /**
   * Converts the Funding to a plain object (useful for serialization)
   * @returns Plain object representation
   */
  toObject(): Record<string, unknown> {
    return {
      Code: this.Code,
      Name: this.Name,
      Payer: this.Payer,
      Percentage: this.Percentage,
      FederalParticipation: this.FederalParticipation,
    };
  }
}


